export const permisions: any = {
  account: {
    name: "Quản lý tài khoản",
    child: {
      list_acc: { name: "Xem danh sách đăng ký" },
      delete_acc: { name: "Xoá tài khoản" },
      view_info: { name: "Xem thông tin tài khoản" },
      edit_info: { name: "Sửa thông tin tài khoản" },
      view_kyc: { name: "Xem thông tin KYC" },
      edit_kyc: { name: "Sửa thông tin KYC" },
      approve_kyc: { name: "Phê duyệt thông tin KYC" },
      view_membershop: { name: "Xem thông tin gói hội viên" },
      edit_membershop: { name: "Chỉnh sửa thông tin gói hội viên" },
      view_wallet: { name: "Xem thông tin ví" },
      deposit: { name: "Nạp tiền thủ công" },
      withdraw: { name: "Rút tiền thủ công" },
      view_transaction: { name: "Xem lịch sử giao dịch" },
      list_kyc: { name: "Xem danh sách yêu cầu KYC" },
    }
  },
  transaction: {
    name: "Quản lý giao dịch & ví",
    child: {
      list: { name: "Xem lịch sử giao dịch" },
      deposit: { name: "Nạp tiền thủ công" },
      withdraw: { name: "Rút tiền thủ công" },
    }
  },
  broker: {
    name: "Quản lý môi giới",
    child: {
      list: { name: "Xem danh sách môi giới" },
      approve: {name: 'Phê duyệt môi giới'},
      view_info: {name: 'Xem profile môi giới'},
      edit_info: {name: 'Chỉnh sửa profile môi giới'},
      eval: {name: 'Đánh giá môi giới'},
    }
  },
  real_estate: {
    name: "Quản lý bất động sản",
    child: {
      list: { name: "Xem danh sách" },
      detail: { name: "Xem chi tiết tin" },
      approve_list: { name: "Xem danh sách tin đăng cần phê duyệt" },
      approve: {name: 'Phê duyệt tin'},
      edit: {name: 'Chỉnh sửa tin'},
      create: {name: 'Tạo tin đăng mới'},
      delete: {name: 'Xoá tin đăng'},
      view_consumer: {name: 'Xem danh sách khách cần tư vấn'},
      view_contract: {name: 'Xem hợp đồng liên quan'},
      view_flash_offer: {name: 'Xem danh sách Flash Offer liên quan'},
    }
  },
  flash_offer:{
    name: "Quản lý Flash Offer",
    child: {
      list: { name: "Xem danh sách Flash Offer" },
      create_flash_offer: {name: 'Tạo Flash Offer'},
      view_flash_offer: {name: 'Xem chi tiết Flash Offer'},
      view_flash_offer_result: {name: 'Xem kết quả chốt deal'},
      stop_flash_offer: {name: 'Ngưng hoạt động Flash Offer'},
    }
  },
  contract:{
    name: "Quản lý Hợp đồng và hoa hồng",
    child: {
      list: { name: "Xem danh sách" },
      create: { name: "Tạo hợp đồng mới" },
      detail: { name: "Xem chi tiết hợp đồng" },
      edit: { name: 'Chỉnh sửa hợp đồng' },
    }
  },
  linked_service:{
    name: "Quản lý Dịch vụ liên kết",
    child: {
      list: { name: "Xem danh sách" },
      create: { name: "Tạo dịch vụ liên kết" },
      detail: { name: "Xem chi tiết dịch vụ" },
      edit: { name: 'Chỉnh sửa dịch vụ' },
      view_campaign: { name: 'Xem danh sách chiến dịch liên kết' },
      campaign_create: { name: 'Tạo chiến dịch liên kết' },
    }
  },
  report:{
    name: "Báo cáo thống kê",
    child: {
      usage: { name: "Xem báo cáo tình hình sử dụng app" },
      transaction: {name: 'Xem báo cáo về ví và giao dịch'},
      commission: {name: 'Xem báo cáo về doanh thu & hoa hồng'},
    }
  },
  cs:{
    name: "Chăm sóc khách hàng",
    child: {
      bulk_message: { name: "Gửi tin hàng loạt" },
      popup: {name: 'Quản lý thông báo popup'},
    }
  },
  setting:{
    name: "Cài đặt hệ thống",
    child: {
      view_version: { name: "Xem danh sách phiên bản" },
      add_version: {name: 'Thêm phiên bản'},
      edit_version: {name: 'Chỉnh sửa phiên bản'},
      view_mbs_plan: { name: "Xem danh sách gói phí hội viên" },
      add_mbs_plan: {name: 'Thêm gói phí hội viên'},
      edit_mbs_plan: {name: 'Chỉnh sửa gói phí hội viên'},
    }
  },
  bo: {
    name: "Quản lý tài khoản Back Office",
    child: {
      list_bo: { name: "Xem danh sách tài khoản BO" },
      view_bo_detail: { name: "Xem chi tiết tài khoản BO" },
      edit_bo_detail: { name: "Chỉnh sửa tài khoản BO" },
      edit_bo_perms: { name: "Chỉnh sửa quyền hạn tài khoản BO" },
      create_bo: { name: "Tạo tài khoản BO" },
      delete_bo: { name: "Xoá tài khoản BO" },
      attendance_view: {name: "Xem danh sách chấm công"},
      attendance_edit: {name: "Chỉnh sửa danh sách chấm công"},
    }
  },
  attendance: {
    name: "Quản lý chấm công",
    child: {
      attendance_view: {name: "Xem danh sách chấm công"},
      attendance_edit: {name: "Chỉnh sửa danh sách chấm công"},
    }
  }
}
